export default "__VITE_ASSET__DLcK6PrJ__"